// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InfoBox-module__infoWrapper___kNbmV {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    text-align: start;
    text-align: -moz-center;
}

    .InfoBox-module__infoWrapper___kNbmV h3 {
        width: 100%;
    }


.InfoBox-module__infoBoxContainer___LQtvA {
    width: fit-content;
    height: fit-content;
    font-size: 1.5rem;
    margin-bottom: 3px;
}

    .InfoBox-module__infoBoxContainer___LQtvA th, .InfoBox-module__infoBoxContainer___LQtvA td {
        padding: 3px 10px;
        text-align: left;
    }

    .InfoBox-module__infoBoxContainer___LQtvA tr > td:not(:first-child) {
        text-align: right;
    }

.InfoBox-module__boxWrapper___AbodQ {
    padding: 1.5rem;
    border: solid;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);
}

@media (min-aspect-ratio: 2) {
    .InfoBox-module__infoBoxContainer___LQtvA {
        padding: 1rem;
    }
}

.InfoBox-module__extraText___uKP25 {
    font-size: 1rem;
}

.InfoBox-module__infoBoxValue___hZR3e {
    white-space: nowrap;
}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/InfoBox/InfoBox.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,uBAAuB;AAC3B;;IAEI;QACI,WAAW;IACf;;;AAGJ;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;IAEI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;AAEJ;IACI,eAAe;IACf,aAAa;IACb,sGAAsG;AAC1G;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".infoWrapper {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n    text-align: start;\n    text-align: -moz-center;\n}\n\n    .infoWrapper h3 {\n        width: 100%;\n    }\n\n\n.infoBoxContainer {\n    width: fit-content;\n    height: fit-content;\n    font-size: 1.5rem;\n    margin-bottom: 3px;\n}\n\n    .infoBoxContainer th, .infoBoxContainer td {\n        padding: 3px 10px;\n        text-align: left;\n    }\n\n    .infoBoxContainer tr > td:not(:first-child) {\n        text-align: right;\n    }\n\n.boxWrapper {\n    padding: 1.5rem;\n    border: solid;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1), 0 6px 6px rgba(0, 0, 0, 0.1), 0 0 100px rgba(0, 0, 0, 0.1);\n}\n\n@media (min-aspect-ratio: 2) {\n    .infoBoxContainer {\n        padding: 1rem;\n    }\n}\n\n.extraText {\n    font-size: 1rem;\n}\n\n.infoBoxValue {\n    white-space: nowrap;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"infoWrapper": `InfoBox-module__infoWrapper___kNbmV`,
	"infoBoxContainer": `InfoBox-module__infoBoxContainer___LQtvA`,
	"boxWrapper": `InfoBox-module__boxWrapper___AbodQ`,
	"extraText": `InfoBox-module__extraText___uKP25`,
	"infoBoxValue": `InfoBox-module__infoBoxValue___hZR3e`
};
export default ___CSS_LOADER_EXPORT___;
